export const SHOW_FIELD_ERROR_CODE = [
  'verify_reset_email_duplicate_other',
  'verify_reset_email_duplicate_self',
  'email_authentication_failed',
  'email_authentication_token_expired',
];
export const RESET_EMAIL_PURPOSE_TYPE = 'RESET_EMAIL';
